<template>
  <div>
    <h2 class="black--text">Dokumentasi presensi peserta Laporan Pembukaan IHT</h2>
    <v-row class="my-1">
      <v-col cols="12" class="py-1">
        <v-btn :href="berkas" target="_blank" color="primary" depressed>
          <v-icon left>mdi-eye</v-icon> Lihat Dokumen
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DokumentasiAbsensi',
  props: {
    berkas: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped></style>
